import { apiClient } from './ApiClient'

export interface MfaSetupResponse {
  success: boolean
  secret: string
  qrCodeDataUri: string
  message: string
}

export interface MfaConfirmResponse {
  success: boolean
  recoveryCodes: string[]
  message: string
}

export interface MfaVerifyResponse {
  success: boolean
  message: string
  remainingRecoveryCodes?: number
}

export interface MfaStatusResponse {
  success: boolean
  mfaEnabled: boolean
  remainingRecoveryCodes: number
}

export interface MfaDisableResponse {
  success: boolean
  message: string
}

export interface MfaRegenerateRecoveryCodesResponse {
  success: boolean
  recoveryCodes: string[]
  message: string
}

class MfaService {
  /**
   * Initiate MFA enrollment - generates QR code and secret
   */
  async initiateEnrollment(): Promise<MfaSetupResponse> {
    return await apiClient.post<MfaSetupResponse>('/mfa/enable/init', {})
  }

  /**
   * Confirm MFA enrollment with verification code
   */
  async confirmEnrollment(code: string): Promise<MfaConfirmResponse> {
    return await apiClient.post<MfaConfirmResponse>('/mfa/enable/confirm', { Code: code })
  }

  /**
   * Verify MFA code during login
   */
  async verifyMfaCode(email: string, code: string): Promise<MfaVerifyResponse> {
    return await apiClient.post<MfaVerifyResponse>('/mfa/verify', {
      Email: email,
      Code: code
    })
  }

  /**
   * Get current MFA status
   */
  async getStatus(): Promise<MfaStatusResponse> {
    return await apiClient.get<MfaStatusResponse>('/mfa/status')
  }

  /**
   * Disable MFA for current user
   */
  async disable(password: string): Promise<MfaDisableResponse> {
    return await apiClient.post<MfaDisableResponse>('/mfa/disable', { Password: password })
  }

  /**
   * Regenerate recovery codes
   */
  async regenerateRecoveryCodes(code: string): Promise<MfaRegenerateRecoveryCodesResponse> {
    return await apiClient.post<MfaRegenerateRecoveryCodesResponse>('/mfa/recovery-codes/regenerate', { Code: code })
  }
}

export const mfaService = new MfaService()
